
import React from "react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Button,
  Progress
 } from "reactstrap";
import {
  Link
} from "react-router-dom";
import "assets/css/custom.css";
import SuperAdminService from '../../services/api/SuperAdmin';
import { toast } from 'react-toastify';
import ScaleLoader from "react-spinners/ScaleLoader";
import LoadingOverlay from 'react-loading-overlay';
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import ReactTable from "react-table";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import Pagination from "../../assets/js/Pagination";
import { Scrollbars } from 'react-custom-scrollbars';

class AdminManagement extends React.Component { 
  constructor(props) {
    super(props);
           
    this.state = {
      userdetails:[],
      columns:[],
      swidth: window.innerWidth,
      sheight: window.innerHeight,
      loading: false,
      percent:'',
      };
      this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
      if (this.state.percent < 30) {
        this.state.hoursstatus = "bg-success"
      }
      if (this.state.percent >= 30) {
        this.state.hoursstatus = "bg-warning"
      }
      if (this.state.percent >= 70) {
        this.state.hoursstatus = "bg-danger"
      }
      this.state.columns = [
        {
        Header: 'Id',
        accessor: 'Id',
        sortable: true,
        show: false
      },
        {
      Header: 'Name',
      accessor: 'Name',
      sortable: true,
       }, 
       {
        Header: 'Description',
        accessor: 'Description'
      },
      {
      Header: 'Email',
      accessor: 'Email'
    },
    {
      Header: 'Free Credits',
      accessor: 'hours',
    },
    {
      Header: 'Account Type',
      accessor: 'accountType'
    },
    {
      Header: 'Url',
      accessor: 'Url'
    },
    {
      Header: 'Actions',
      accessor: 'Actions'
    }
  ];
};


  
  componentDidMount() {
   this.GetAllTenant();
   this.updateWindowDimensions();
   window.addEventListener('resize', this.updateWindowDimensions);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }
  
  updateWindowDimensions() {
    this.setState({ swidth: window.innerWidth, sheight: window.innerHeight});
  }

  GetAllTenant  = () =>{
    this.setState( { loading:true} );
    SuperAdminService.getAllTenant()
    .then((response) => {
      if (response.status === 'SUCCESS') {
        let tenantDto = response.organisationDTOS;
        this.renderData(tenantDto);  
        this.setState( { loading:false} );
          } else {
            toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
          }
    })
  }

  // Edit user mgt
  EditParticularuser(id){
    this.props.history.push({
      pathname: '/newaccount',
      state: { editId: id,mode:"edit" }
    })
  }

  DeleteTenantConfirm = (name,id) =>{
    confirmAlert({
      title: 'Remove Tenant',
      message: 'Are you sure to remove this tenant -' + name + '?',
      buttons: [
        {
          label: 'Yes',
          onClick: e => this.DeleteTenant(id)
        },
        {
          label: 'No',
          onClick: () => console.log('')
        }
      ]
    });
  }

  activeTenantConfirm = (name,id) =>{
    confirmAlert({
      title: 'Activate Tenant',
      message: 'Are you sure to activate this tenant -' + name + '?',
      buttons: [
        {
          label: 'Yes',
          onClick: e => this.ActivateTenant(id)
        },
        {
          label: 'No',
          onClick: () => console.log('')
        }
      ]
    });
  }

  deactiveTenantConfirm = (name,id) =>{
    confirmAlert({
      title: 'Deactivate Tenant',
      message: 'Are you sure to Deactivate this tenant -' + name + '?',
      buttons: [
        {
          label: 'Yes',
          onClick: e => this.DeactivateTenant(id)
        },
        {
          label: 'No',
          onClick: () => console.log('')
        }
      ]
    });
  }


  DeleteTenant(id){
       SuperAdminService.removeParticularTenant(id)
        .then((response) => {
            toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Tenant Deleted Successfully!</b></i>); 
            this.GetAllTenant(); 
        });
   }

   ActivateTenant(id){
    SuperAdminService.activateParticularTenant(id)
     .then((response) => {
         if (response.status === 'SUCCESS') {
         toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Tenant Activated Successfully!</b></i>); 
         this.props.history.push('/accounts');    
         } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
        }
     });
}

DeactivateTenant(id){
  SuperAdminService.deactivateParticularTenant(id)
   .then((response) => {
       if (response.status === 'SUCCESS') {
       toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Tenant Deactivate Successfully!</b></i>); 
       this.props.history.push('/accounts');    
       } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
      }
   });
}


  renderData(userData){
    let datas = [];
   
    userData.map((item, index) => {
      if (item.consumedPercentage < 30) {
        this.state.hoursstatus = "bg-success"
      }
      if (item.consumedPercentage >= 30) {
        this.state.hoursstatus = "bg-warning"
      }
      if (item.consumedPercentage >= 70) {
        this.state.hoursstatus = "bg-danger"
      }
      datas.push({
        Id: item.id, 
        Name:<div className="namedisplay">{item.name}</div>,
        Description:<div className="namedisplay">{item.description}</div>,
        Email:<div className="namedisplay">{item.email}</div>,
        hours: item.accountType === "NEW" && <div className="namedisplay"><span className="mr-2">{item.consumedPercentage > 100 ? 100 : item.consumedPercentage }%</span><Progress
       max="100"
       value={item.consumedPercentage}
       barClassName={this.state.hoursstatus}
     /></div> ,
        accountType:<div className="namedisplay">{item.accountType}</div>,
        Url:<div className="namedisplay">{item.url}</div>,
        Actions:<div><i style={{cursor:"pointer",color:"53b1dd"}} onClick={e=>this.EditParticularuser(item.id)} className="fa fa-edit"/>
        &nbsp; &nbsp;<i style={{cursor:"pointer",color: "#d3d3d3"}} 
        className="fa fa-trash-alt notinuse"/>
        &nbsp; &nbsp;<i style={{cursor:"pointer",color: "#d3d3d3"}} 
        className="fa fa-lock notinuse"/>
        </div>,

       })
     });
     this.setState({
       userdetails:datas
     });

}

  render() {
    return (
      <>
      <PanelHeader
          content={
            <div className="header text-center">
            
            </div>
          }
        />
          <div className="content">
          <LoadingOverlay
      active={this.state.loading}
      spinner={<ScaleLoader
        height={35}
        width={5}
        radius={2}
        margin={2}
        color={"#123abc"}
        loading={this.state.loading}
      />}
    >
          <Row>
            <Col xs={12} md={12}>
           <Row>
            <div className=" col">
              <Card>
                <CardHeader>
                   <Row className="align-items-center">
                    <div className="col">
                      <h5 className="mb-0">Accounts</h5>
                  
                    </div>
                    <div className="col text-right">
                      <Link to="accounts" > 
                       <span> <i className="fas fa-sync-alt mr-3" onClick={e =>this.GetAllTenant()}/></span>
                      </Link>
                       <Link to={{
                        pathname: 'newaccount',
                        state: { mode: "addnew" }
                      }}>
                         <Button
                        color="primary"
                        href="#pablo"
                        size="sm"
                      >
                      Create Tenant
                      </Button>
                      </Link>
                    </div>
                  </Row>
                </CardHeader>
                <CardBody>
                <div className="carcontent">
                <Scrollbars autoHeight autoHeightMin={this.state.sheight-220}>  
     
        <ReactTable
         data={ this.state.userdetails }
         columns={ this.state.columns }
         defaultPageSize={10}
         showPaginationBottom={true}
         PaginationComponent={Pagination}
         className="-striped -highlight Usertable"
          />
    
       </Scrollbars>
       </div>
                </CardBody>
              </Card>
            </div>
          </Row>
          
          </Col>
          </Row>
          </LoadingOverlay>
          </div>
      </>
    );
  }
}

export default AdminManagement;